import { Typography } from '@mui/material';
import styled from 'styled-components';
import { localizeDate } from '@elementary/common-ui/utils/datetime';
import { getGroupingStrategyDisplay } from '../../utils';
import { IncidentDetail } from '../../types';

const RowValue = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.black};
  font-size: 13px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  row-gap: 16px;
  column-gap: 16px;
`;

const RowLabel = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray2};
  font-size: 13px;
`;

const Wrapper = styled.div`
  padding: 8px 0;
`;

const AttributeValue = ({
  attribute,
}: {
  attribute: IncidentDetail['attributes'][number];
}) => (
  <>
    <RowLabel>{attribute.displayName}</RowLabel>
    <RowValue>
      {attribute.data.dateValue != null
        ? localizeDate(attribute.data.dateValue).format('L LT')
        : attribute.data.stringListValue?.join(', ') ??
          attribute.data.stringValue}
    </RowValue>
  </>
);

type Props = {
  attributes: IncidentDetail['attributes'];
  groupingStrategy: IncidentDetail['groupingStrategy'];
};

const IncidentAttributes = ({ attributes, groupingStrategy }: Props) => (
  <Wrapper>
    <Grid>
      <RowLabel>Grouped by</RowLabel>
      <RowValue>{getGroupingStrategyDisplay(groupingStrategy)}</RowValue>
      {attributes.map((attribute) => (
        <AttributeValue key={attribute.id} attribute={attribute} />
      ))}
    </Grid>
  </Wrapper>
);

export default IncidentAttributes;
